import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function LamesCassees() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Close%20up%20of%20damaged%20and%20cracked%20white%20aluminum%20roller%20shutter%20slats%20on%20a%20tablier%20showing%20clear%20signs%20of%20breakage%20and%20needing%20replacement%20in%20a%20residential%20exterior%20clean%20daylight%20professional%20photography%20warm%20neutral%20tones&width=700&height=520&seq=tab-lames&orientation=landscape" alt="Lames de tablier de volet roulant cassées" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Lames cassées ou tablier abîmé
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Le tablier de volet roulant est constitué de lames articulées qui s'enroulent dans le coffre en hauteur. Ces lames subissent des contraintes mécaniques importantes : poids du tablier, vibrations du vent, chocs accidentels, et usure des glissières. Une lame en aluminium peut se déformer ou se fissurer sous l'impact d'un projectile. Une lame en PVC peut se briser en cas de gel intense ou de choc violent. Lorsqu'une lame est endommagée, elle perturbe l'enroulement complet et risque de bloquer le volet dans les glissières.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Nos techniciens interviennent sur tous les types de tabliers : en aluminium, en PVC, en acier galvanisé. Nous identifions d'abord l'ampleur des dégâts : lames cassées isolées, section entière du tablier tordue, ou tablier complet percé. Si le dommage est localisé, nous remplaçons uniquement les lames concernées. Pour un tablier trop abîmé, nous proposons un remplacement complet avec un calibrage précis.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              L'intervention commence par la dépose du tablier existant, l'inspection des glissières latérales et le contrôle de l'état du coffre. Nous vérifions que les axes d'articulation des lames sont intacts et que le mécanisme d'enroulement fonctionne correctement. Seulement après ce diagnostic, nous procédons au remplacement.
            </p>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}